<div class="modal-header">
  <h5 class="modal-title" i18n>Edit Subject and Message</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <mat-form-field2 class="mat-block">
      <input
        matInput
        type="text"
        formControlName="title"
        i18n-placeholder
        placeholder="Message Title"
        i18n-matTooltip
        matTooltip="Enter a title for the message. This will appear as the subject header of the email sent to the recipient."
      />
    </mat-form-field2>
    <mat-form-field2 class="mat-block">
      <textarea formControlName="message" cdkTextareaAutosize [rows]="5" i18n-placeholder placeholder="Message">
      </textarea>
    </mat-form-field2>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()"><ng-container i18n>Cancel</ng-container></button>

  <button type="submit" class="btn btn-secondary-info" (click)="onSave(form)">
    <i class="fas fa-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
